import { axiosInstance } from "../apiurls/apiurls";
import {
  GET_ALL_TOPICS,
  GET_TOPIC_BY_KEY,
  GET_ALL_TOPIC_PAGE_CONTENT,
  GET_TOPIC_PAGE_CONTENT_BY_ID,
  GET_ALL_TOPIC_INSTITUTION_PAGE_CONTENT,
  GET_TOPIC_INSTITUTION_PAGE_CONTENT_BY_ID,
  GET_ONE_TOPIC_COMPLETED_URL,
} from "../apiurls/apiurls";


export const getAllTopics = async (subjectKey) => {
  try {
    const response = await axiosInstance.get(`${GET_ALL_TOPICS}?subject_key=${subjectKey}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching topics:", error);
    throw error;
  }
};

export const getTopicByKey = async (key) => {
  try {
    const response = await axiosInstance.get(`${GET_TOPIC_BY_KEY}?key=${key}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching topic by key:", error);
    throw error;
  }
};

export const getAllTopicPageContent = async (topicKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_TOPIC_PAGE_CONTENT}?topic_key=${topicKey}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all topic page content:", error);
    throw error;
  }
};

export const getTopicPageContentById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_TOPIC_PAGE_CONTENT_BY_ID}?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching topic page content by id:", error);
    throw error;
  }
};

export const getAllTopicInstitutionPageContent = async (topicKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_TOPIC_INSTITUTION_PAGE_CONTENT}?topic_key=${topicKey}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all topic institution page content:", error);
    throw error;
  }
};

export const getTopicInstitutionPageContentById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_TOPIC_INSTITUTION_PAGE_CONTENT_BY_ID}?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching topic institution page content by id:", error);
    throw error;
  }
};

export const getOneTopicCompletedApi = async (pageId) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ONE_TOPIC_COMPLETED_URL}?page_id=${pageId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching one topic completed:", error);
    throw error;
  }
};

